import React from 'react';

import noop from 'lodash/noop';

import FormBase from '../base/Form';
import { FormProvider } from './FormContext';
import useForm from './useForm';


const Form = React.forwardRef((props, ref) => {
  const {
    sx,
    children,
    onSubmit = noop,
    onSuccess = noop,
    onError = noop,
    onInvalid = noop,
    ...restProps
  } = props;

  const { handleSubmit, ...form } = useForm(restProps);

  return (
    <FormProvider form={{ handleSubmit, ...form }}>
      <FormBase
        ref={ref}
        sx={sx}
        onSubmit={handleSubmit({ onSubmit, onSuccess, onError, onInvalid })}
      >
        {children}
      </FormBase>
    </FormProvider>
  );
});

Form.displayName = 'FormGeneric';
export default Form;
